module.exports = __webpack_public_path__ + "img/2.c860e44d.jpg";